<!-- HeaderContent.vue -->
<template>
  <header class="header">
    <!-- Top Bar (Logos and Title) -->
    <div class="top-bar lg:mt-16">
      <div class="logo-container">
        <a href="/" class="logo-link">
          <img src="./../../assets/sglm-logo-1.png" alt="Shree Ghoghari Lohana Mahajan Logo 1" class="logo-img">
        </a>
      </div>
      <div class="title-container">
        <a href="/" class="title-link">
          <h1 class="title-english">Shree Ghoghari Lohana Mahajan, Mumbai</h1>
          <h1 class="title-gujarati">શ્રી ઘોઘારી લોહાણા મહાજન, મુંબઈ</h1>
        </a>
      </div>
      <div class="logo-container">
        <a href="/" class="logo-link">
          <img src="./../../assets/sglm-logo-2.png" alt="Shree Ghoghari Lohana Mahajan Logo 2" class="logo-img">
        </a>
      </div>
    </div>

    <!-- Main Navigation Bar -->
    <nav class="main-nav max-w-[100rem] mx-auto">
      <!-- Mobile Menu Button -->
      <button class="menu-toggle" @click="toggleMenu" aria-label="Toggle navigation menu">
        <svg class="w-6 h-6" fill="none" :stroke="isMenuOpen ? 'white' : '#00395a'" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
        </svg>
      </button>

      <!-- Navigation Links (Desktop & Mobile) -->
      <div :class="{'is-active': isMenuOpen}" class="nav-links">
        <a href="/" class="nav-item">Home</a>
        <DropdownMenu title="About" link="/about" :items="aboutItems" />
        <DropdownMenu title="Institutions" link="/institutions" :items="instituionItems" />
        <a href="/donations" class="nav-item">Donations</a>
        <DropdownMenu title="Services" link="/services" :items="serviceItems" />
        <a href="/accounts" class="nav-item">Accounts</a>
        <a href="/events" class="nav-item">Events</a>
        <a href="/gallery" class="nav-item">Gallery</a>
        <a href="/contact" class="nav-item">Contact Us</a>
      </div>
    </nav>
  </header>
</template>

<script>
import { ref } from 'vue'; // Using Composition API ref for simplicity
import DropdownMenu from './DropdownMenu.vue';
export default {
  data() {
    return {
      aboutItems: [
        { text: 'History of Lohana Community', link: '/about/history-of-lohana-community/' },
        { text: 'History of SGLM', link: '/about/history-of-sglm' },
        { text: 'The Committee', link: '/about/the-committee' },
        { text: 'Trustees', link: '/about/trustees' },
        { text: 'Past Presidents', link: '/about/past-presidents' },
        { text: 'Past Vice Presidents', link: '/about/past-vice-presidents' },
        { text: 'Salahkar Samiti', link: '/about/salahkar-samiti' },
        { text: 'Varni Samiti', link: '/about/varnisamiti' }
      ],
      instituionItems: [
        { text: 'KBCT', link: 'https://khimjibhagwandascharitytrust.org/' },
        { text: 'Mahila Mandal', link: '/mahila-mandal' },
        { text: 'Yuvak Mandal', link: '/yuvak-mandal' },
        { text: 'Other Institutions', link: '/other-institutions' },
      ],
      serviceItems: [
        { text: 'Download Aid Form', link: '/download-forms/' },
        { text: 'Conference Hall', link: '/conference-hall' },
        { text: 'Banquet Hall', link: '/banquet-hall' },
        { text: 'Rooms on Rent', link: '/rooms-on-rent' },
      ],
      galleryItems: [
        { text: 'Annual General Meeting', link: '/download-forms' },
        { text: 'Cricket', link: '/cricket' },
        { text: 'Inaugration', link: '/inaugration' },
        { text: 'Medical Camp', link: '/medical-camp' },
        { text: 'Yatra Pravas', link: '/yatra-pravas' },
        { text: 'Sneh Milan', link: '/sneh-milan' },
        { text: 'Yoga Camp', link: '/yoga-camp' },
        { text: 'Independence Day', link: '/independence-day' },
        { text: 'E-Waste Recycling Campaign', link: '/e-waste-campaign' },
        { text: 'Mithai Vitran', link: '/mithai-vitran' },
        { text: 'Raas Garba', link: '/raas-garba' },
        { text: 'Skill Development', link: '/skill-development' },
        { text: 'Vadlo Yatra Pravas', link: '/vadlo-yatra-pravas' },
      ]
    }
  },
  components: {
    DropdownMenu
  },
  name: 'HeaderContent',
  setup() {
    const isMenuOpen = ref(false);

    const toggleMenu = () => {
      isMenuOpen.value = !isMenuOpen.value;
    };
    return { isMenuOpen, toggleMenu };
  }
}
</script>

<style scoped>
@import 'tailwindcss/base';
@import 'tailwindcss/components';
@import 'tailwindcss/utilities';

.header {
  @apply bg-white shadow-md w-full max-w-[100rem]; /* Moved sticky classes here */
}

.top-bar {
  @apply flex justify-between items-center px-4 py-4 sm:px-6 md:px-8 lg:px-16 bg-cover bg-center;
  background-image: url('./../../assets/SGLM_Header02.jpg');
}

.logo-container {
  @apply flex-shrink-0;
}

.logo-img {
  @apply w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 object-contain;
}

.title-container {
  @apply flex-grow text-center mx-4;
}

.title-link {
  @apply no-underline text-white;
}

.title-english {
  @apply font-bold text-xl sm:text-3xl md:text-4xl lg:text-5xl leading-tight;
}

.title-gujarati {
  @apply text-base sm:text-xl md:text-2xl mt-1 leading-tight;
}

/* Main Navigation Bar */
.main-nav {
  @apply bg-[#00395a] text-white w-full;
  @apply shadow-md fixed top-0 z-50; /* Removed sticky from here */
  @apply flex justify-center items-center; /* Added relative for mobile menu positioning */
}

/* Mobile Menu Toggle Button */
.menu-toggle {
  @apply p-2 focus:outline-none lg:hidden absolute right-0 top-0 z-50 cursor-pointer; /* Position top-right on mobile */
}

/* Navigation Links Container */
.nav-links {
  @apply hidden lg:flex flex-row justify-center items-center w-full lg:h-16 font-bold; /* Desktop: flex row, centered */
  @apply sm:space-x-6 md:space-x-6 lg:space-x-7 xl:space-x-10; /* Responsive spacing */
}

/* Mobile Menu Active State */
.nav-links.is-active {
  @apply block absolute top-0 left-0 w-full bg-[#00395a] shadow-lg py-20 text-center; /* Mobile: block, full width, positioned below toggle */
  @apply flex flex-col items-center space-y-4; /* Mobile: flex column, centered, vertical spacing */
}

/* Individual Navigation Items */
.nav-item {
  @apply text-white no-underline text-base sm:text-lg hover:underline px-2 py-1; /* Responsive text size, hover effect */
  @apply block w-full sm:w-auto text-center; /* Mobile: block, full width text center */
}

/* Style for DropdownMenu component when active in mobile menu */
.nav-links.is-active .dropdown {
  @apply w-full text-center; /* Ensure dropdown takes full width in mobile menu */
}

/* Style for DropdownMenu title link */
.nav-links .dropdown > a {
  @apply text-white no-underline text-base sm:text-lg hover:underline px-2 py-1 block w-full sm:w-auto text-center;
}
</style>